// extracted by mini-css-extract-plugin
export default {"link":"RM-z","disabled":"SM-z"};